<template>

  <div class="flex flex-col justify-center py-12 sm:px-6 lg:px-8">

    <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
      <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
        <img class="w-auto h-20 mx-auto mt-1" src="@/assets/hp/kairo-logo-v2.png" alt="Kairo">
        <h2
          class="text-gray-700 font-medium text-center mb-2"
        >Create your account</h2>
        <h3 class="text-gray-700 text-sm text-center mb-2">Start your free trial</h3>

        <button
          type="button"
          :disabled="lockButtons"
          @click="signUpWithGoogle"
          class="disabled:opacity-50 w-full inline-flex justify-center items-center gap-3 rounded-md border border-gray-300 bg-white px-4 py-3 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 mb-6"
        >
          <svg class="h-5 w-5" viewBox="0 0 24 24" aria-hidden="true">
            <path fill="#EA4335" d="M12 10.2v3.9h5.4c-.2 1.3-1.7 3.9-5.4 3.9-3.2 0-5.9-2.7-5.9-6s2.7-6 5.9-6c1.8 0 3 .8 3.7 1.4l2.5-2.4C16.6 3.4 14.5 2.5 12 2.5 6.9 2.5 2.8 6.6 2.8 11.7S6.9 20.9 12 20.9c6.9 0 8.6-4.9 8.6-7.4 0-.5-.1-.9-.1-1.3H12z"/>
            <path fill="#4285F4" d="M3.8 7.2l3.2 2.3c.9-1.8 2.8-3 5-3 1.8 0 3 .8 3.7 1.4l2.5-2.4C16.6 3.4 14.5 2.5 12 2.5c-3.6 0-6.8 2.1-8.2 4.7z"/>
            <path fill="#FBBC05" d="M12 20.9c2.4 0 4.4-.8 5.8-2.2l-2.8-2.2c-.8.5-1.8.9-3 .9-2.2 0-4.1-1.4-4.8-3.4l-3.3 2.5c1.4 2.8 4.5 4.4 8.1 4.4z"/>
            <path fill="#34A853" d="M3.8 16.6l3.3-2.5c-.2-.6-.3-1.3-.3-2s.1-1.3.3-2L3.8 7.6C3.2 8.8 2.8 10.2 2.8 11.7s.4 2.9 1 4.9z"/>
          </svg>
          Continue with Google
        </button>

        <div class="relative mb-6">
          <div class="absolute inset-0 flex items-center">
            <div class="w-full border-t border-gray-300"></div>
          </div>
          <div class="relative flex justify-center text-sm">
            <span class="bg-white px-2 text-gray-500">or sign up with email</span>
          </div>
        </div>

        <p class="text-center text-sm text-green-700 m-2">
          Join <strong>394</strong> users who started using Kairo in March.
        </p>

        <div v-if="msgError" class="rounded-md bg-red-50 p-4">
          <div class="flex">
            <div class="flex-shrink-0">
              <!-- Heroicon name: x-circle -->
              <svg class="h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
              </svg>
            </div>
            <div class="ml-3">
              <h3 class="text-sm font-medium text-red-800">
                There was a problem!
              </h3>
              <div class="mt-2 text-sm text-red-700">
                {{msgError}}
              </div>
            </div>
          </div>
        </div>
        <div v-if="msgSuccess" class="rounded-md bg-green-50 p-4">
          <div class="flex">
            <div class="flex-shrink-0">
              <!-- Heroicon name: x-circle -->
              <svg class="h-5 w-5 text-green-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
              </svg>
            </div>
            <div class="ml-3">
              <h3 class="text-sm font-medium text-green-800">
                Please check your email!
              </h3>
              <div class="mt-2 text-sm text-green-700">
                {{msgSuccess}}
              </div>
            </div>
          </div>
        </div>

        <div>
          <Form
            @submit="signup()"
            class="space-y-6"
          >
            <div>
              <label for="email" class="block text-sm font-medium text-gray-700">
                Name
              </label>
              <div class="mt-1">
                <Field
                  id="name"
                  name="name"
                  v-model="crendentials.name"
                  type="text"
                  :rules="isRequired"
                  class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />
                <ErrorMessage name="name" class="mt-2 text-sm text-red-600" />
              </div>
            </div>
            <div>
              <label for="email" class="block text-sm font-medium text-gray-700">
                Email address
              </label>
              <div class="mt-1">
                <Field
                  id="email"
                  v-model="crendentials.email"
                  type="email"
                  name="email"
                  :rules="validateEmail"
                  placeholder="hey@email.com"
                  autocomplete="email" required class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />
                <ErrorMessage name="email" class="mt-2 text-sm text-red-600" />
              </div>
            </div>

            <div>
              <label for="password" class="block text-sm font-medium text-gray-700">
                Password
              </label>
              <div class="mt-1">
                <i :class="[passwordIcon]" @click="hidePassword = !hidePassword"></i>
                <Field
                        v-model="crendentials.password"
                        :type="passwordType"
                        id="password"
                        name="password"
                        :rules="validatePassword"
                        autocomplete="current-password" required class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />
                <ErrorMessage name="password" class="mt-2 text-sm text-red-600" />
              </div>
            </div>

            <div class="text-sm text-gray-700">
              By signing up, I accept the Kairo <a href="https://getkairo.com/terms" class="underline">Terms of Service</a> and acknowledge the <a href="https://getkairo.com/privacy-policy" class="underline">Privacy Policy</a>.
            </div>

            <div>
              <button
                :disabled="lockButtons"
                class="disabled:opacity-50 w-full border-green-600 border-2 border-b-3 items-center p-2 pb-3 rounded-lg shadow-sm text-green-600 bg-green-200 hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-50"
                style="box-shadow: inset 0px -6px 0px #34D399, inset 0 -7px 0 0 #ECFDF5, inset 0px 1px 0px 1px #ECFDF5;"
              >
                Start trial
              </button>
            </div>
          </Form>
        </div>

        <div class="mt-6">
          <div class="relative">
            <div class="absolute inset-0 flex items-center">
              <div class="w-full border-t border-gray-300"></div>
            </div>
            <div class="relative flex justify-center text-sm">
            <span class="px-2 bg-white text-gray-500">
            </span>
            </div>
          </div>
          <div>
            <div class="relative flex justify-center text-sm mt-4">
              <span class="px-2 bg-white text-gray-500">
                <router-link
                  to="/login"
                  class="font-medium text-indigo-600 hover:text-indigo-500"
                >Already have a Kairo account? Log in
                </router-link>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <AppFooter />

</template>

<script>
  import { mapActions } from "vuex";
  import { Field, Form, ErrorMessage } from 'vee-validate';
  import AppFooter from '../components/AppFooter.vue';
  import { resolveAuthRedirect } from '../helpers/login-redirect';

  export default {
    components: {
      Field,
      Form,
      ErrorMessage,
      AppFooter
    },
    data() {
      return {
        crendentials: {
          name: "",
          password: "",
          email: ""
        },
        hidePassword: true,
        toggleModal: false,
        lockButtons: false,
        msgError: null,
        msgSuccess: null
      };
    },
    computed: {
      passwordType() {
        return this.hidePassword ? "password" : "text";
      },
      passwordIcon() {
        return this.hidePassword ? "eye-open" : "eye-closed";
      },
    },
    methods: {
      ...mapActions("auth", [
        "attemptSignup",
        "attemptExternalLogin",
        "completeExternalLogin",
      ]),
      async signUpWithGoogle() {
        this.msgError = '';
        this.msgSuccess = '';
        this.lockButtons = true;

        try {
          await this.attemptExternalLogin({
            provider: 'google',
            redirectTo: window.location.href,
          });
        } catch (error) {
          this.msgError = `${error}`;
          this.lockButtons = false;
        }
      },
      async completeExternalLoginFromCallback() {
        const hasOAuthCode = new URLSearchParams(window.location.search).has('code');
        const hash = window.location.hash || '';
        const hasOAuthHash = ['access_token=', 'refresh_token=', 'error=', 'error_code=', 'error_description=']
          .some(fragment => hash.includes(fragment));

        if (!hasOAuthCode && !hasOAuthHash) {
          return;
        }

        this.lockButtons = true;
        this.msgError = '';

        try {
          const currentUser = await this.completeExternalLogin();
          this.$router.replace(resolveAuthRedirect(this.$route.query, currentUser));
        } catch (error) {
          this.msgError = `${error}`;
          this.lockButtons = false;
        }
      },
      signup() {
        this.msgError = '';
        this.msgSuccess = '';
        this.lockButtons = true;
        this.attemptSignup(this.crendentials)
          .then((result) => {
            if (result && result.requiresEmailConfirmation === false) {
              this.$router.push(resolveAuthRedirect(this.$route.query, result.currentUser || null));
              return;
            }

            this.msgSuccess = `A confirmation email has been sent to you.`;
            this.lockButtons = false;
          })
          .catch(error => {
            this.msgError = `${error}`;
            this.lockButtons = false;
          });
      },
      isRequired(value) {
        return value ? true : 'This field is required';
      },
      validateEmail(value) {
        if (!value) {
          return 'This field is required';
        }
        if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,10}$/i.test(value)) {
          return 'This field must be a valid email';
        }
        return true;
      },
      validatePassword(value) {
        if (!value) {
          return 'This field is required';
        }
        if (value.length < 8) {
          return 'Password must have at least 8 characters';
        }
        return true;
      }
    }
    ,
    mounted() {
      this.completeExternalLoginFromCallback();
    }
  };
</script>
